/** Material Symbols Rounded, ligature style — the icon set the handoff specifies.
 *  Optical size 17–19px is the design's range; `size` defaults to 19 (nav). */
export function Icon({ name, size = 19, color, style, className }: {
  name: string
  size?: number
  color?: string
  style?: React.CSSProperties
  className?: string
}) {
  return (
    <span className={`mi${className ? ` ${className}` : ''}`} aria-hidden="true" style={{ fontSize: size, color, ...style }}>
      {name}
    </span>
  )
}
